import { render, staticRenderFns } from "./ResolveOptions.vue?vue&type=template&id=54ed47c9&scoped=true"
import script from "./ResolveOptions.vue?vue&type=script&lang=js"
export * from "./ResolveOptions.vue?vue&type=script&lang=js"
import style0 from "./ResolveOptions.vue?vue&type=style&index=0&id=54ed47c9&prod&lang=scss&module=true&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "54ed47c9",
  null
  
)

export default component.exports